import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';

export function useApiMessagesLastUpdated(): number {
    return useContext(MobXProviderContext).RootStore.apiMessagesStore.lastUpdatedDelay;
}
